/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Available = 0, Unavailable = 1, NotWorking = 2
 */
export enum Routemize_DTOs_Availability_TeamMemberAvailabilityStatus {
    AVAILABLE = 'Available',
    UNAVAILABLE = 'Unavailable',
    NOT_WORKING = 'NotWorking',
}
